export const UpdateValuesModal = (data, setCurrentData, setModal) => {
    setCurrentData(data)
    setModal(true)
}